import { bool, object } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import {
  useEstimateEditorStore,
  useEstimateEditorSettings,
  ElementChatPopup,
  VisibilityButton, useEstimateStructure
} from "@tools";
import { TooltipIcon } from "@components";
import { Percent } from "@assets";
import { Badge } from "@material-ui/core";
import { useMemo } from "react";
import { getPercentWorkTypes } from "@utils";

export const WorkTypeActions = observer(({ workType, opened }) => {
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  const { visibilityMode } = useEstimateEditorStore();
  const { allowEdition, showChatThread } = useEstimateEditorSettings();

  const {
    name,
    treePath,
    hideOnTimeline,
    percentageWorkTypes,
    cellAutomatedWorkTypes,
  } = workType;

  const commentPath = "t" + treePath.join("/");


  const percentWorkTypes = useMemo(() => (
    getPercentWorkTypes(percentageWorkTypes)
  ), [ structure.percentageWorkTypes, percentageWorkTypes ]);

  const automatedWorkTypes = useMemo(() => (
    getPercentWorkTypes(cellAutomatedWorkTypes.of)
  ), [ structure.percentageWorkTypes, cellAutomatedWorkTypes ]);

  return (
    <>
      {
        allowEdition && percentWorkTypes.length > 0 &&
        <TooltipIcon icon={<Percent />} color="primary" className="noDrag ml-2">
          {percentWorkTypes}
        </TooltipIcon>
      }
      {
        allowEdition && automatedWorkTypes.length > 0 &&
        <Badge
          color="secondary"
          badgeContent={cellAutomatedWorkTypes.counter}
          overlap="circular"
          max={9}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <TooltipIcon icon={<Percent />} color="secondary" className="noDrag ml-2">
            {automatedWorkTypes}
          </TooltipIcon>
        </Badge>
      }
      {
        visibilityMode &&
        <VisibilityButton
          hidden={hideOnTimeline}
          onChange={workType.setHideOnTimeline}
          inRow
        />
      }
      {
        showChatThread &&
        <ElementChatPopup
          rowThread
          path={commentPath}
          taskName={name || t("common.unnamed")}
          hideBadge={opened}
        />
      }
    </>
  );
});

WorkTypeActions.propTypes = {
  workType: object.isRequired,
  opened: bool,
};
